import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import omit from 'transmute/omit';
import { Map as ImmutableMap } from 'immutable';
import setIn from 'immutable-less/transmute/setIn';
function loadSessionStorageQueries() {
  try {
    const persistedQueries = sessionStorage.getItem('persistedQueries');
    return ImmutableMap(JSON.parse(persistedQueries) || {});
  } catch (error) {
    return ImmutableMap();
  }
}
function updateSessionStorageQueries(newQueries) {
  try {
    sessionStorage.setItem('persistedQueries', JSON.stringify(newQueries));
  } catch (error) {
    return;
  }
}
const initialState = {
  flowEnableErrors: {},
  testFlow: {},
  zoomLevel: 1,
  bulkProcessingStatusByFlowId: ImmutableMap(),
  persistedQueries: loadSessionStorageQueries(),
  isCanvasVirtualRenderingDisabled: false,
  isResolutionPanelOpen: false,
  isInResolutionMode: false
};
export default function platformFlowsApplication(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_CANVAS_VIRTUAL_RENDERING:
      return Object.assign({}, state, {
        isCanvasVirtualRenderingDisabled: action.isCanvasVirtualRenderingDisabled
      });
    case ActionTypes.ADD_FLOW_ENABLE_ERRORS:
      return Object.assign({}, state, {
        flowEnableErrors: Object.assign({}, state.flowEnableErrors, action.errors)
      });
    case ActionTypes.REMOVE_FLOW_ENABLE_ERRORS:
      return Object.assign({}, state, {
        flowEnableErrors: omit(action.errorIds, state.flowEnableErrors)
      });
    case ActionTypes.TEST_FLOW_WITH_OBJECT:
      return Object.assign({}, state, {
        testFlow: Object.assign({}, state.testFlow, {
          flowId: action.flowId,
          objectId: action.objectId,
          options: action.options
        })
      });
    case ActionTypes.HIGHLIGHT_ACTIONS:
      return Object.assign({}, state, {
        highlightedActionIds: action.actionIds ? new Set(action.actionIds.toArray()) : null
      });
    case ActionTypes.SET_BULK_PROCESSING_STATUS:
      {
        const {
          bulkProcessingStatus,
          flowId
        } = action;
        return Object.assign({}, state, {
          bulkProcessingStatusByFlowId: state.bulkProcessingStatusByFlowId.set(flowId, bulkProcessingStatus)
        });
      }
    case ActionTypes.SET_BULK_PROCESSING_POLLING_STATUS:
      {
        const {
          flowId,
          shouldPollBulkProcessing
        } = action;
        return Object.assign({}, state, {
          bulkProcessingStatusByFlowId: setIn([flowId, 'shouldPollBulkProcessing'], shouldPollBulkProcessing, state.bulkProcessingStatusByFlowId)
        });
      }
    case ActionTypes.SET_QUERY_PERSIST:
      {
        const {
          key,
          value
        } = action;
        const persistedQueries = state.persistedQueries.merge({
          [key]: value
        });
        updateSessionStorageQueries(persistedQueries);
        return Object.assign({}, state, {
          persistedQueries
        });
      }
    case ActionTypes.REMOVE_QUERY_PERSIST:
      {
        const {
          key
        } = action;
        const persistedQueries = state.persistedQueries.delete(key);
        updateSessionStorageQueries(persistedQueries);
        return Object.assign({}, state, {
          persistedQueries
        });
      }
    case ActionTypes.REMOVE_QUERY_PERSIST_BY_REGEX:
      {
        const {
          regex,
          modifier
        } = action;
        const exp = modifier ? RegExp(regex, modifier) : RegExp(regex);
        const persistedQueries = state.persistedQueries.filter((value, key) => !exp.test(key));
        updateSessionStorageQueries(persistedQueries);
        return Object.assign({}, state, {
          persistedQueries
        });
      }
    case ActionTypes.SET_RESOLUTION_MODE:
      {
        const {
          isInResolutionMode
        } = action.payload;
        return Object.assign({}, state, {
          isInResolutionMode,
          isResolutionPanelOpen: isInResolutionMode
        });
      }
    case ActionTypes.CLOSED_ACTION_CONFIG_RELAXED_VALIDATION:
      {
        const {
          isInResolutionMode
        } = state;
        return Object.assign({}, state, {
          isResolutionPanelOpen: isInResolutionMode
        });
      }
    case ActionTypes.OPENED_ACTION_CONFIG_RELAXED_VALIDATION:
      {
        const {
          actionHasValidationErrors
        } = action.payload;
        const {
          isInResolutionMode
        } = state;
        return Object.assign({}, state, {
          isInResolutionMode: isInResolutionMode && actionHasValidationErrors,
          isResolutionPanelOpen: false
        });
      }
    default:
      return state;
  }
}